import { flattenTree, listToTree } from '../../../helpers';

export function normalizeNestedToFlatList(items) {
  const result = [];

  const walk = (nodes) => {
    nodes.forEach((node) => {
      const { subComponents, children, ...rest } = node;
      result.push(rest);
      const nested = subComponents || children || [];
      if (nested.length) {
        walk(nested);
      }
    });
  };

  walk(items);
  return result;
}

export function buildListTreeFromFlatList(flatList) {
  if (!flatList?.length) {
    return [];
  }

  const cloned = JSON.parse(JSON.stringify(flatList));
  const tree = listToTree(cloned, 'parentComponentId');
  const list = flattenTree(tree, 'children');
  if (list.length) {
    list.shift();
  }

  return list;
}

export function updateComponentInFlatList(flatList, componentId, updater) {
  return flatList.map((component) => (
    component.id === componentId
      ? { ...component, ...updater(component) }
      : component
  ));
}

export function upsertComponentsInFlatList(flatList, newItems) {
  const normalized = normalizeNestedToFlatList(Array.isArray(newItems) ? newItems : [newItems]);
  const byId = new Map(flatList.map((component) => [component.id, component]));

  normalized.forEach((item) => {
    byId.set(item.id, { ...byId.get(item.id), ...item });
  });

  return Array.from(byId.values());
}

export function getDescendantIds(rootId, flatList) {
  const descendants = [];

  const walk = (parentId) => {
    flatList
      .filter((component) => component.parentComponentId === parentId)
      .forEach((child) => {
        descendants.push(child.id);
        walk(child.id);
      });
  };

  walk(rootId);
  return descendants;
}

export function upsertActivityInFlatList(flatList, componentId, activity) {
  return updateComponentInFlatList(flatList, componentId, (component) => {
    const activities = [...(component.activities || [])];
    const index = activities.findIndex((item) => item.id === activity.id);

    if (index === -1) {
      activities.push({
        ...activity,
        status: activity.status || 'opened',
      });
    } else {
      activities[index] = {
        ...activities[index],
        ...activity,
        status: activity.status || activities[index].status || 'opened',
      };
    }

    return { activities };
  });
}
